import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const STEPS = [
  { n: "01", t: "Apply Securely", d: "Complete the confidential application in under 4 minutes over a 256-bit encrypted connection." },
  { n: "02", t: "Instant Review", d: "Our underwriting team reviews your submission and returns a preliminary decision the same business day." },
  { n: "03", t: "Personal Concierge", d: "A dedicated advisor walks you through terms, answers questions, and finalises the disbursement path." },
  { n: "04", t: "Funds Transferred", d: "Approved capital is wired directly to your account — often within 24 hours of closing." },
];

export default function ProcessSection() {
  return (
    <section id="how-it-works" className="mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-36">
      <div className="text-[10px] uppercase tracking-[0.32em] text-[#D4AF37]">The Process</div>
      <h2 className="mt-4 max-w-3xl font-serif text-4xl font-light leading-tight sm:text-5xl">
        Four steps. Concierge throughout.
      </h2>

      <div className="mt-16 grid gap-8 md:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((p) => (
          <div key={p.n} className="relative border-t border-[#D4AF37]/40 pt-8" data-testid={`process-step-${p.n}`}>
            <div className="font-serif text-5xl font-light text-[#D4AF37]">{p.n}</div>
            <h3 className="mt-6 font-serif text-2xl font-light">{p.t}</h3>
            <p className="mt-3 text-sm leading-relaxed text-white/60">{p.d}</p>
          </div>
        ))}
      </div>

      <div className="mt-16 flex flex-col items-start gap-6 border border-white/10 bg-white/[0.02] p-8 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <div className="text-[10px] uppercase tracking-[0.32em] text-[#D4AF37]">Ready When You Are</div>
          <p className="mt-3 font-serif text-2xl font-light">
            Begin your confidential application — takes under 4 minutes.
          </p>
        </div>
        <Link
          to="/apply"
          data-testid="process-cta"
          className="inline-flex items-center gap-3 border border-[#D4AF37] bg-[#D4AF37] px-8 py-4 text-xs uppercase tracking-[0.32em] text-[#050A1F] transition-colors hover:bg-[#F3E5AB]"
        >
          Fill Application <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </section>
  );
}
